import { render, staticRenderFns } from "./page-team-insights.vue?vue&type=template&id=2f518658&scoped=true"
import script from "./page-team-insights.vue?vue&type=script&lang=js"
export * from "./page-team-insights.vue?vue&type=script&lang=js"
import style0 from "./page-team-insights.vue?vue&type=style&index=0&id=2f518658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f518658",
  null
  
)

export default component.exports